import Icon from 'veui/components/Icon'
import { IconLocationCopy } from 'dls-icons-vue'

Icon.register('location-copy', IconLocationCopy)
